import { UserWorkspaceRole } from "@common/userWorkspaceRoles";
import { useActiveWorkspaceRole } from "@hooks/permissions/useActiveWorkspaceRole";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useUser } from "@hooks/useUser";

export enum OnboardingMode {
    CREATE_ACCOUNT = "CREATE_ACCOUNT", // registration
    ONBOARDING = "ONBOARDING", // creating a new workspace or organization, regular user
    INVITE = "INVITE", // invited to either workspace or organization as member
    BILLING_OWNER_INVITE = "BILLING_OWNER_INVITE", // invited to a workspace where client owns the billing
}

export function useOnboardingMode() {
    const user = useUser();
    const activeWorkspace = useActiveWorkspace();
    const activeWorkspaceRole = useActiveWorkspaceRole();
    const activeOrganization = useActiveOrganization();

    if (!user) {
        return OnboardingMode.CREATE_ACCOUNT;
    }

    if (
        (activeWorkspace && !activeWorkspace.onboardingCompletedAt) ||
        (activeOrganization && !activeOrganization.onboardingCompletedAt)
    ) {
        return OnboardingMode.ONBOARDING;
    }

    if (
        !user.onboardingCompletedAt &&
        activeWorkspaceRole === UserWorkspaceRole.PRIMARY_ADMIN
    ) {
        return OnboardingMode.BILLING_OWNER_INVITE;
    }

    if (
        !user.onboardingCompletedAt &&
        (activeOrganization || activeWorkspace)
    ) {
        return OnboardingMode.INVITE;
    }

    return null;
}
